import React, { useState } from 'react';
import { classNames } from 'shared/lib/classNames/classNames';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useApi } from 'app/api/APIProvider';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import SubmitButton from 'shared/assets/img/pages/plot/submitButton.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPlotStepData, plotStepData, plotStepsActions } from 'widgets/PlotSteps';
import { APIError } from 'app/api/NewAPI';
// import { userActions } from 'features/User';
import { AppLink, AppLinkTheme } from 'shared/ui/AppLink/AppLink';
import cls from './DynamicAnswer.module.scss';

interface IDynamicAnswerForm {
    sum: number
}
interface DynamicAnswerProps {
    className?: string
}

const DynamicAnswerSchema = Yup.object().shape({
    sum: Yup.number()
        .min(1, 'Укажите сумму больше 0')
        .max(100000, 'Не больше 100 000')
        .required('Сумма не указана'),
});

export const DynamicAnswer = (props: DynamicAnswerProps) => {
    const {
        className,
    } = props;
    const [showNextButton, setShowNextButton] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const stepData = useSelector(getPlotStepData);
    const api = useApi();
    const user = api.User;
    const [isDisabledButton, setIsDisabledButton] = useState<boolean>(false);

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors, isValid },
    } = useForm<IDynamicAnswerForm>({
        // @ts-ignore
        resolver: yupResolver(DynamicAnswerSchema),
    });

    const changeStep = (e: any) => {
        e.preventDefault();

        setIsDisabledButton(true);
        api.EditUser({
            current_scene: {
                plotStep: 45,
                previousStep: 39,
            },
        }).then(() => {
            user.current_scene = {
                plotStep: 45,
                previousStep: 39,
            };

            setTimeout(() => {
                dispatch(plotStepsActions.addedPlotStepData(plotStepData(45, user)));
                setIsDisabledButton(false);
            }, 500);
            navigate('/');
        }).catch((error) => {
            console.log(error);
        });
    };

    const onSubmit: SubmitHandler<IDynamicAnswerForm> = async (data) => {
        const user2 = api.User;
        const linkOnStep = stepData?.action?.linkOnStep;

        try {
            await api.DoScam({
                amount: data.sum,
            });
            const { wallet } = await api.GetAllSum();
            const plotOptions = {
                wallet,
            };
            await api.EditUser({
                current_scene: {
                    plotStep: linkOnStep,
                },
                // profession_id: data.sum,
            });
            dispatch(plotStepsActions.addedPlotStepData(plotStepData(linkOnStep, user2, plotOptions)));
        } catch (e: unknown) {
            const error = e as APIError;

            setShowNextButton(true);

            setError('sum', {
                type: 'manual',
                message: error.Message,
            });
        }
    };

    return (
        <div className={classNames(cls.DynamicAnswer, {}, [className])}>
            {showNextButton
                && (
                    <AppLink
                        to="/"
                        className={cls.nextButton}
                        theme={AppLinkTheme.NEXT}
                        disabled={isDisabledButton}
                        onClick={(e) => changeStep(e)}
                    >
                        Пройти дальше
                    </AppLink>
                )}
            {/*@ts-ignore*/}
            <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={cls.cell}>
                    <input
                        type="number"
                        className={cls.field}
                        placeholder="Укажи сумму перевода"
                        {...register('sum', { required: 'Сумма не указана' })}
                    />
                    {errors.sum && <p className={cls.error}>{errors.sum.message}</p>}
                    <Button
                        className={cls.submitButton}
                        theme={ButtonTheme.ONLY_ICON}
                        type="submit"
                        icon={<SubmitButton />}
                        disabled={!isValid}
                    />
                </div>
            </form>
        </div>
    );
};
